var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        {
          attrs: {
            "border-color": _vm.data.status.color,
            controlled: "",
            "has-toggle": "",
            opened: _vm.data.opened
          },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c("div", { staticClass: "p-2 bg-gray" }, [
                    _c(
                      "div",
                      { staticClass: "p-3 bg-white" },
                      [
                        _c("question-form", {
                          attrs: {
                            id: _vm.data.id,
                            header: {
                              visible: true,
                              title: "Cuestionario de Propuesta",
                              iconClass: "fas fa-file mr-3 my-2 text-orange"
                            },
                            "is-preview": "",
                            "is-read-only": ""
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row py-2 mr-md-0 n-ml" }, [
            _c("div", { staticClass: "col-12 col-md-6 text-start" }, [
              _c("div", [
                _c("span", { staticClass: "font-16 text-muted" }, [
                  _vm._v(" No. de Cuestionario: ")
                ])
              ]),
              _c("div", [
                _c("span", { staticClass: "font-16 color-black" }, [
                  _vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.number)) + " ")
                ])
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-4 custom-pl" }, [
              _c("div", { staticClass: "d-flex flex-column" }, [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v(" Nombre del Cuestionario: ")
                ]),
                _c("span", { staticClass: "font-16 color-black" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.data.questionnaireType.name)) +
                      " "
                  )
                ])
              ])
            ]),
            !_vm.isReadOnly
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-2 custom-pl d-flex align-items-center justify-content-md-end"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-md-end h-100"
                      },
                      [
                        _c("check-box", {
                          staticClass: "row-check",
                          attrs: { value: _vm.data.checked },
                          on: { input: _vm.onToggle }
                        })
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }